/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayerSearchOptions } from './PayerSearchOptions';
import {
    PayerSearchOptionsFromJSON,
    PayerSearchOptionsFromJSONTyped,
    PayerSearchOptionsToJSON,
    PayerSearchOptionsToJSONTyped,
} from './PayerSearchOptions';

/**
 * 
 * @export
 * @interface GetInovalonPayerSearchOptions200Response
 */
export interface GetInovalonPayerSearchOptions200Response {
    /**
     * 
     */
    data?: PayerSearchOptions;
}

/**
 * Check if a given object implements the GetInovalonPayerSearchOptions200Response interface.
 */
export function instanceOfGetInovalonPayerSearchOptions200Response(value: object): value is GetInovalonPayerSearchOptions200Response {
    return true;
}

export function GetInovalonPayerSearchOptions200ResponseFromJSON(json: any): GetInovalonPayerSearchOptions200Response {
    return GetInovalonPayerSearchOptions200ResponseFromJSONTyped(json, false);
}

export function GetInovalonPayerSearchOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInovalonPayerSearchOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PayerSearchOptionsFromJSON(json['data']),
    };
}

export function GetInovalonPayerSearchOptions200ResponseToJSON(json: any): GetInovalonPayerSearchOptions200Response {
    return GetInovalonPayerSearchOptions200ResponseToJSONTyped(json, false);
}

export function GetInovalonPayerSearchOptions200ResponseToJSONTyped(value?: GetInovalonPayerSearchOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayerSearchOptionsToJSON(value['data']),
    };
}

